import { useNavigate, useLocation } from "react-router-dom";
import { HTTPURL, REQUEST_OPTIONS } from "../constants/matcher";
import { toast } from 'react-toastify';
import {forwardRef, useImperativeHandle} from 'react';

const Child = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const location = useLocation();

    useImperativeHandle(ref, () => ({

        login(requestData, type) {        
            REQUEST_OPTIONS.method = 'POST';
            REQUEST_OPTIONS.body = JSON.stringify(requestData);
        
            if(type=='user'){
                var url = 'login';
            }else{
                var url = 'admin';
            }
        
            fetch(HTTPURL + url, REQUEST_OPTIONS)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
        
                if (!response.ok) {
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }
        
                if(data.status===true){
                    localStorage.setItem('user-token', JSON.stringify(data.accessToken));
                    localStorage.setItem('user-data', JSON.stringify(data.data));
        
                    var now = new Date().getTime();
                    localStorage.setItem('setupTime', now)
        
                    toast.success(data.message)
        
                    let state = location.state;
        
                    if(type=='user'){
                        // var stateless = (data.data[0].userType==0) ? '/civil-servant' : '/mentor';
                        var stateless = (data.data[0].userType==0) ? (data.data[0].similer_training?'/civil-servant':'/civil-servant/survey') : (data.data[0].similer_training?'/mentor':'/mentor/survey');
                    }else{
                        var stateless = '/secure/dashboard';
                    }
                    
                    let from = state ? state.from.pathname : stateless;
                    navigate(from, { replace: true });
                }else{
                    toast.error(data.message)
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },

        logout(type) {
            const loggedInUser = localStorage.getItem("user-token");
            if (loggedInUser) {
                localStorage.clear();
                
                if(type=='user'){
                    toast.success("User logged out")
                    navigate("/");
                }else{
                    toast.success("Admin logged out")
                    navigate("/secure");
                }
            }
        },

    }));

//   return (
//     <div>
//       <h2>child content</h2>
//     </div>
//   );
});

export {Child};
